module.exports = __webpack_public_path__ + "img/tablet_scorebuilder.0e436614.jpg";